const defaultQuestions = {
  wantToFeature: {
    label: 'What are the products, services or promotions that you want to feature on social?',
    // eslint-disable-next-line max-len
    placeholder: 'List up to 10 products, services or promotions that you would like to post on social. IE Happy hour, Sales, new arrivals, long term offerings, customer favourites. The more, the better, this is the content base we will built your social posts off of.',
  },
  stockPhotoApproval: {
    label: 'We prioritize any photos you provide — Can we source additional photos if needed?',
    placeholder: '',
    options: [
      { value: '', label: 'Choose' },
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
    required: true,
    type: 'select',
  },
  brandColor: {
    label: 'What is your primary brand colour?',
    placeholder: '',
    type: 'color',
  },
};

export default defaultQuestions;
